import { Stack, Typography, Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import policyService from "../../services/policyService";
import { cardStyle, ThemeModeContext } from "../../shared/Theme";

const CardComplianceHub = () => {

	const navigate = useNavigate();
	const themeModeContext = useContext(ThemeModeContext);
	
	let [ policyStats, setPolicyStats ] = useState(policyService.policyStats);
	
	const handleTitleClick = () => {
		navigate("/training");
	};
	
	useEffect(() => {
		setPolicyStats(policyService.policyStats);
	}, []);
	
	const options = {
		indexAxis: "y",
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				suggestedMin: 0,
				suggestedMax: 100,
				ticks: {
					beginAtZero: true
				}
			}
		},
		maintainAspectRatio: false
	};
	
	const getData = () => {
		const data = {
			labels: [ "Unviewed %", "Viewed %", "Signed %" ],
			datasets: [{
				label: "Policies",
				data: [
					(policyStats.percentViewed === 0)? 0 : 100 / policyStats.percentViewed,
					policyStats.percentViewed,
					policyStats.percentSigned
				],
				backgroundColor: [
					"#00FBD9",
					"#47ab9c",
					"#FF00FF"
				],
				borderColor: (themeModeContext.themeMode === "light")?
					"rgba(0, 0, 0, 0.87)" : "rgba(255, 255, 255, 0.87)",
				fill: true,
			}]
		};
		
		return data;
	}
	
	return (
		<React.Fragment>
			<Stack
				direction="column"
				onClick={handleTitleClick}
				sx={{ ...cardStyle, width: "28em", height: "16em", '&:hover': { cursor: "pointer" } }}
			>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						cursor: "pointer",
						fontWeight: "bold"
					}}
					onClick={handleTitleClick}
				>
					Compliance Hub
				</Typography>
				<Box sx={{ width: "80%", height: "60%", margin: "auto" }}>
					<Bar data={getData()} options={options} width="100%" height="100%"/>
				</Box>
			</Stack>
		</React.Fragment>
	);

}

export default CardComplianceHub;